import { useState, useEffect } from "react";
import api from "../../api/axios";

import { CommonSubHeader } from "../../Components/helpers/Helpers";
import {
  Divider,
  Box,
  Chip,
  Grid,
  Fade,
  ButtonGroup,
  Button,
  Typography,
  FormControl,
} from "@mui/material";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { pdfjs } from "react-pdf";
import LoadPdf from "./LoadPdf/LoadPdf";

import { useLocationHelpers } from "../../Components/helpers/Helpers";
import { useSearchParams } from "react-router-dom";
// Configuración del worker de PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const Ver = () => {
  const { goPanel, goTable, goEdit } = useLocationHelpers();
  // Obtener bookId desde query string
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get("id");

  // Estados
  const [bookName, setBookName] = useState("");
  const [bookDescription, setBookDescription] = useState("");
  const [book, setBook] = useState("");
  const [tags, setTags] = useState([]);
  const [flag, setFlag] = useState(false);

  // Funciones

  const textareaStyle = {
    resize: "none", // Evitar el cambio de tamaño
    border: "none", // Eliminar los bordes
    padding: "10px", // Espacio interno
    fontSize: "13px", // Tamaño de la fuente
    width: "100%", // Ocupa el ancho completo
    height: "100px", // Altura ajustable
    outline: "none", // Eliminar el borde de enfoque
    boxShadow: "none", // Eliminar cualquier sombra de caja
  };

  // Generar un color aleatorio
  const getRandomDarkColor = () => {
    const r = Math.floor(Math.random() * 128);
    const g = Math.floor(Math.random() * 128);
    const b = Math.floor(Math.random() * 128);
    return `rgb(${r}, ${g}, ${b})`;
  };

  const chipsStyles = {
    margin: 4,
    padding: "15px",
    boxShadow: "0px 0px 7px 0px gray",
    borderRadius: "4px",
  };

  // Obtener los datos del libro
  const getData = async () => {
    console.log(bookId);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/library/show`,
        { libro: bookId },
      );

      const bookData = data?.book ?? {};

      console.log(data);
      setBook(bookData);

      // Usa el campo correcto para el archivo PDF (puede ser file, doc_file, etc.)
      const fileName = bookData.file || bookData.doc_file || "";
      setBookName(fileName);

      // Descripción segura (sin romper si viene null o undefined)
      const description = (bookData.description || "").replace(
        /<br\s*\/?>/gi,
        "\n",
      );
      setBookDescription(description);

      // Manejo seguro de tags
      const rawTags = bookData.tags || "";
      const tagsArray = rawTags.includes(",")
        ? rawTags.split(",")
        : rawTags
          ? [rawTags]
          : [];
      setTags(tagsArray);

      setFlag(true);
    } catch (error) {
      console.error("   Error al obtener el libro:", error);
      setFlag(false);
    }
  };

  // Cargar datos al montar el componente
  useEffect(() => {
    getData();
  }, [bookId]);

  return (
    <div>
      <CommonSubHeader title="Biblioteca" subTitle="Ver" />

      <Fade timeout={600} in={flag}>
        <div>
          <ButtonGroup
            sx={{
              width: "100%",
              background: "white",
            }}>
            <Button
              onClick={() => goEdit("biblioteca", bookId, "Libro")}
              variant="contained"
              color="info"
              fullWidth>
              Editar
            </Button>
            <Button
              onClick={() => goTable("biblioteca", "Biblioteca")}
              variant="outlined"
              color="error"
              fullWidth>
              Tabla
            </Button>
          </ButtonGroup>
          <Grid
            container
            spacing={2}
            sx={{
              backgroundColor: "white",
              borderRadius: "4px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              padding: 3,
            }}>
            <Grid item xs={12}>
              <Divider sx={{ borderColor: "rgb(102 119 213 / 59%)", mb: 2 }} />
              <Typography
                variant="h6"
                textAlign="center"
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  color: "#333",
                  fontSize: "15px",
                }}>
                {book.title}
              </Typography>
              <Divider sx={{ borderColor: "rgb(102 119 213 / 59%)", mt: 2 }} />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                sx={{
                  mb: 1,
                  color: "#444",
                  fontWeight: "bold",
                  fontSize: "15px",
                }}>
                TAGS
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {tags.map((tag, index) => (
                  <Chip
                    key={index}
                    label={tag.toUpperCase()}
                    size="small"
                    variant="outlined"
                    sx={{
                      borderColor: getRandomDarkColor(),
                      color: getRandomDarkColor(),
                      fontWeight: "500",
                      boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                      borderRadius: "4px",
                    }}
                  />
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                sx={{
                  mb: 1,
                  color: "#444",
                  fontWeight: "bold",
                  fontSize: "15px",
                }}>
                INTRODUCCIÓN
              </Typography>

              <FormControl style={{ width: "100%" }}>
                <textarea
                  readOnly
                  style={{
                    height: "100px",
                    resize: "none",
                    padding: "6px 13px",
                    outline: "none",
                    fontSize: "14px",
                    border: "1px solid #ccc",
                    color: "#333",
                    backgroundColor: "#f9f9f9",
                  }}
                  value={bookDescription}
                />
              </FormControl>
            </Grid>
          </Grid>
        </div>
      </Fade>
      <div>
        {bookName != "" && <LoadPdf bookName={bookName} bookId={bookId} />}
      </div>
    </div>
  );
};

export default Ver;
